import { getIcon } from "assets/icons/icons-list";
import classNames from "classnames";
import ContentIconSelector from "components/campaigns/icons/content-icon-selector";
import Checkbox from "components/checkbox/checkbox";
import InputField from "components/input/input";
import { useEffect, useState } from "react";
import http from "services/https";

function InputDesc({ children }) {
  return <p class="text-sm">{children}</p>;
}

export default function PopupAdvancedOptions({ id, onUpdate }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState();
  const [options, setOptions] = useState({});
  const [values, setValues] = useState({});

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await http.get(`popups/${id}/advanced`);
        setOptions(data.options);
        setValues(data.data);
        setLoading(false);
      } catch (e) {
        console.error(e);
        setError("error loading options");
        setOptions({});
        setValues({});
      }
    })();
  }, [id]);

  const updateOption = (key, value, save = false) => {
    const newValues = { ...values, [key]: value };
    setValues(newValues);
    if (save) {
      saveChanges(newValues);
    }
  };

  const saveChanges = async (newValues = undefined) => {
    const _newValues = newValues ?? values;

    if (saving) {
      return;
    }
    setSaving(true);
    setError();

    try {
      const { data } = await http.patch(`popups/${id}/advanced`, _newValues);
      setValues(data.data);
      onUpdate?.(data.data);
    } catch (e) {
      console.error(e);
      setError("error saving options, see console");
    }

    setSaving(false);
  };

  return (
    <>
      {loading && <p className="mb-2">Loading...</p>}
      {error && <p className="text-red mb-2">{error}</p>}
      <div class={classNames(saving && "opacity-50", "flex flex-col gap-2")}>
        {Object.entries(options).map(([key, settings]) => {
          switch (settings.type) {
            case "boolean":
              return (
                <div key={key}>
                  <Checkbox
                    name={key}
                    checked={!!values[key]}
                    label={settings.title}
                    onChange={(e) =>
                      updateOption(key, !!e.currentTarget.checked, true)
                    }
                  />
                  <InputDesc>{settings.description}</InputDesc>
                </div>
              );
            case "icon":
              return (
                <div key={key}>
                  <p>{settings.title}</p>
                  <div class="mb-5">
                    <ContentIconSelector
                      onClick={(e) => updateOption(key, e?.id, true)}
                      Icon={getIcon(values[key])}
                    />
                  </div>
                  <InputDesc>{settings.description}</InputDesc>
                </div>
              );
            default:
              return (
                <div key={key}>
                  <InputField
                    outsideLabelClass="p-0 m-0"
                    value={values[key]}
                    outsideLabel={settings.title}
                    noLabelPaddingY="0.25rem"
                    name={key}
                    placeholder={settings.default}
                    type="text"
                    onInput={(e) => updateOption(key, e.currentTarget.value)}
                    onChange={(e) => updateOption(key, e.currentTarget.value)}
                    onBlur={() => saveChanges()}
                    additionalStyles={{ marginTop: 0 }}
                    autocomplete="none"
                  />
                  <InputDesc>{settings.description}</InputDesc>
                </div>
              );
          }
        })}
      </div>
      {saving && <p class="mt-2">Saving...</p>}
    </>
  );
}
